var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.goalBooklet)?_c('div',{staticClass:"page with-title-bar"},[_c('div',{staticClass:"content full-screen with-title-bar",domProps:{"innerHTML":_vm._s(_vm.goalBooklet.booklet.embed_code)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }